import { render, staticRenderFns } from "./vy2.vue?vue&type=template&id=0fbb92c1&scoped=true"
import script from "./vy2.vue?vue&type=script&lang=js"
export * from "./vy2.vue?vue&type=script&lang=js"
import style0 from "./vy2.vue?vue&type=style&index=0&id=0fbb92c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbb92c1",
  null
  
)

export default component.exports